import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=56d4e505&scoped=true"
import script from "./GroupCreate.vue?vue&type=script&lang=ts"
export * from "./GroupCreate.vue?vue&type=script&lang=ts"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=56d4e505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4e505",
  null
  
)

export default component.exports